import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9 9-4.0294 9-9a9 9 0 0 0-9-9m.9 9a.9.9 0 0 1-.261.639l-2.7 2.7A.9.9 0 0 1 8.67 14.07l2.43-2.439V7.5a.9.9 0 0 1 1.8 0z",
    clipRule: "evenodd"
}), "StatusExpired", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
